/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum PAYER_NAME_TYPE {
  USE_DEFAULT = 1,
  USE_MANUALLY_INPUT = 2,
}
